import { AfterContentInit, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalGenericComponent } from '../../../shared/components/modal-generic/modal-generic.component';
import { GtmService } from '../../../shared/services/gtm/gtm.service';
import { ConfirmationService } from '../../../vass-core/components/modal/confirmation.service';
import { NotaryAddress, SignatureModel } from '../../models/signature.model';
import { MortgageService } from '../../services/mortgage/mortgage.service';
import { SignatureService } from '../../services/signature/signature.service';

declare var google: any;

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss'],
  standalone: false,
})
export class SignatureComponent implements OnInit, AfterContentInit {
  private map: any;

  public signature: SignatureModel;
  public mapError: boolean;
  public address: string;

  constructor(
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    private signatureService: SignatureService,
    private mortgageService: MortgageService,
    private gtm: GtmService,
  ) {}

  ngOnInit() {
    this.getSignatureData();
    this.gtm.sendVarGTM({ pageType: 'Firma' });
  }

  ngAfterContentInit(): void {
    this.initMap();
  }

  private initMap() {
    this.map = new google.maps.Map(document.getElementById('map'), { zoom: 15 });
  }

  private getSignatureData() {
    this.signatureService.getSignatureData().subscribe((response) => {
      this.signature = response;
      this.address = this.concatAddress(
        this.signature.mortgagesSignCrmData.mortgageNotaryData.notaryAddress,
      );
      this.findPlace(
        this.signature.mortgagesSignCrmData.mortgageNotaryData.notaryName,
        this.address,
      );
    });
  }

  private findPlace(notaryName: string, address: string) {
    const geocoder = new google.maps.Geocoder();
    if (geocoder) {
      geocoder.geocode({ address, region: 'es' }, (results, status) => {
        if (
          status === google.maps.GeocoderStatus.OK &&
          status !== google.maps.GeocoderStatus.ZERO_RESULTS
        ) {
          this.map.setCenter(results[0].geometry.location);

          const infowindow = new google.maps.InfoWindow({
            content: `  <p>${notaryName}</p>
                                    <b>${results[0].formatted_address}</b>`,
            size: new google.maps.Size(150, 50),
          });

          const marker = new google.maps.Marker({
            position: results[0].geometry.location,
            map: this.map,
            title: address,
            icon: 'assets/img/favicon.ico',
          });

          google.maps.event.addListener(marker, 'click', function () {
            infowindow.open(this.map, marker);
          });
        } else {
          this.mapError = true;
        }
      });
    } else {
      this.mapError = true;
    }
  }

  public openModal(id: string) {
    const data = {
      message: this.translate.instant(`documentation.info_${id}`),
      txtButton: this.translate.instant('btn_aceptar'),
    };
    const options: Object = {
      header: this.translate.instant(`documentation.name_${id}`),
      showHeader: true,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm(<any>{
      component: ModalGenericComponent,
      options: options,
      data: data,
      accept: (data) => {},
      reject: () => {},
    });
  }

  getProvince(id: string) {
    const ccaa = this.mortgageService.ccaa.find((e) => e.id === id);
    return ccaa ? ccaa.name : '';
  }

  concatAddress(address: NotaryAddress) {
    let street = address.roadType ? this.translate.instant(address.roadType) : '';
    street = street ? `${street} ${address.roadName}` : address.roadName;
    if (address.roadNumber) {
      street = `${street}, ${address.roadNumber}`;
    }
    if (address.door) {
      street = `${street} ${address.door}`;
    }
    if (address.zip) {
      street = `${street}, ${address.zip}`;
    }
    const province = this.mortgageService.findProvince(address.province);
    if (province.toLocaleLowerCase() === address.city.toLocaleLowerCase()) {
      street = `${street} ${address.city}`;
    } else {
      street = `${street} ${address.city}, ${province}`;
    }

    return street;
  }
}
